import { ICellRendererParams, ICellRendererComp } from 'ag-grid-community'
import { Collection, Deal } from 'api'
import './AssignableNameCellRenderer.css'
import { Locale, Translation } from 'locale'

export const getCollectionNameText = (collection: Collection | null | undefined) =>
  collection?.name ?? Locale.translate(Translation.TC_COLLECTION_UNASSIGNED)

export const getBasketDealIdText = (deal: Deal | null | undefined) =>
  deal?.basketDealId ?? (deal?.basketAllocation ? deal.dealId : Locale.translate(Translation.TC_SINGLE_TRADES))

export interface IAssignableNameRendererParams extends ICellRendererParams {
  unassignedLabel: string
  hideUnassignedLabel: boolean
  dataTestId?: string
}

export class AssignableNameCellRenderer implements ICellRendererComp {
  private eGui: HTMLDivElement | null = null

  public init(params: IAssignableNameRendererParams) {
    this.eGui = document.createElement('div')
    if (params.dataTestId) {
      this.getGui().setAttribute('data-test-id', params.dataTestId)
    }
    this.eGui.classList.add('assignable-name-cell')
    this.refresh(params)
  }

  public getGui(): HTMLElement {
    if (this.eGui) {
      return this.eGui
    } else {
      throw new Error('assignable name eGui is not set')
    }
  }

  public refresh(params: IAssignableNameRendererParams): boolean {
    if (this.eGui) {
      const assignableName = params.valueFormatted || params.value
      const isUnassigned = assignableName === params.unassignedLabel
      const hideLabel = isUnassigned && params.hideUnassignedLabel

      this.eGui.innerHTML = !assignableName || hideLabel ? '' : assignableName
      isUnassigned ? this.eGui.classList.add('unassigned') : this.eGui.classList.remove('unassigned')

      return true
    } else {
      throw new Error('Assignable name cell has not been initialised')
    }
  }

  public destroy() {
    this.eGui = null
  }
}
